import { Address } from "@/models/address/address";
import {
  OrderStatus,
  OrderType,
  PaymentMethod,
  ShippingMethod
} from "@/models/order/helpers";
import { LineItem, LineItemRecord } from "@/models/order/order";
import * as actions from "./actions";
import * as getters from "./getters";
import * as mutations from "./mutations";
import { OrderState } from "./types";

export const defaultState: OrderState = {
  _id: null,
  status: OrderStatus.Open,
  type: OrderType.Quote,
  status_log: [],
  customer_id: "",
  customer_name: "",
  creator_id: "",
  notes: "",
  contact_details: {
    quote_name: "",
    company_name: "",
    contact_name: "",
    phone: "",
    email: ""
  },
  shipping_details: {
    first_name: "",
    last_name: "",
    company_name: "",
    address: {} as Address,
    phone: "",
    email: "",
    method: ShippingMethod.DropShip
  },
  billing_details: {
    first_name: "",
    last_name: "",
    company_name: "",
    address: {} as Address,
    phone: "",
    email: ""
  },
  payment_details: {
    method: undefined,
    card: "",
    auth: undefined
  },
  items: [] as LineItem[],
  cost_details: {
    shipping: null,
    tax: null,
    freight_request: {
      addressType: null,
      services: null,
      shippingZip: null,
      requestDate: null,
      updatedDate: null
    }
  }
};

const state = { ...defaultState };

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
